module.exports = "<p class=\"text-center\">\n  Welcome to Delphina Home Health Administration! <a routerLink=\"/login\">Log in</a> to begin.\n</p>\n"